"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_intl_1 = require("react-intl");
var messages = (0, react_intl_1.defineMessages)({
    modalTitle: {
        id: 'task.taskImport.modal.title',
        defaultMessage: 'Import your task',
        description: 'Task import modal title',
    },
    modalDescription: {
        id: 'task.taskImport.modal.description',
        defaultMessage: 'To import files please select the import-file. Please attach an XML Zip-file. File name should not have more than 32 characters.',
        description: 'Task import modal description',
    },
    subActionText: {
        id: 'task.taskImport.modal.subActionText',
        defaultMessage: 'XML ZIP (Title max. 32 characters)',
        description: 'Task import modal sub drag and drop action text. File format and max chars in title',
    },
    clickText: {
        id: 'task.taskImport.modal.clickText',
        defaultMessage: 'Click to upload',
        description: 'Task import modal click text',
    },
    dragAndDropText: {
        id: 'task.taskImport.modal.dragAndDropText',
        defaultMessage: '(or drag and drop file)',
        description: 'Task import modal drag and drop text',
    },
    tooLongFileNameText: {
        id: 'task.taskImport.modal.tooLongFileNameText',
        defaultMessage: 'The file name exceeds 32 characters. Please rename the file for import',
        description: 'When the file name is too long we notify the users about it',
    },
    successTaskImportTitle: {
        id: 'task.taskImport.modal.successTaskImport.title',
        defaultMessage: 'File successfully imported',
        description: 'A snackbar is displayed after a task file was successfully uploaded with title',
    },
    successTaskImportText: {
        id: 'task.taskImport.modal.successTaskImport.text',
        defaultMessage: 'Your task file has been successfully imported and is now listed in the Task List',
        description: 'A snackbar is displayed after a task file was successfully uploaded with text',
    },
    failedTaskImportTitle: {
        id: 'task.taskImport.modal.failedTaskImport.title',
        defaultMessage: 'File import failed',
        description: 'A Snackbar is displayed when a task import fails with title',
    },
    failedTaskImportText: {
        id: 'task.taskImport.modal.failedTaskImport.text',
        defaultMessage: 'Task file could not be imported. Please try again',
        description: 'A Snackbar is displayed when a task import fails with text',
    },
    failedTaskImportRetry: {
        id: 'task.taskImport.modal.failedTaskImport.retry',
        defaultMessage: 'Retry',
        description: 'A Snackbar is displayed when a task import fails with Retry option',
    },
});
exports.default = messages;
